import React, { useState, useContext } from 'react';
import { Row, Col } from '@thd-olt-component-react/core-ui';
import { Button } from '@one-thd/sui-atomic-components';
import { EPCContext } from '../../contexts/epcContext';
import {
  convertSubsToPrefs, getSubscriptions, updateEmailPreferences
} from '../../common/sharedFunctions';
import { TextModal } from '../TextModal/TextModal';
import { EMAIL_INFORMATION_SECTIONS } from '../../constants/informationPageConstants';
import { BannerContext, BannerProvider } from '../../contexts/BannerContext';
import ErrorBoundary from '../../contexts/ErrorBoundary';
import PreferenceCard from '../PreferenceCard/PreferenceCard';
import { emailTableHeaders } from '../tableData';
import { SignUpModal } from '../SignUpModal/SignUpModal';
import constants from '../../constants/constants';
import { determineMessage } from '../../utils/general';

export function Preferences() {

  const {
    email, setEmail,
    surveyEmailTableData, setSurveyEmailTableData, isMobile
  } = useContext(EPCContext);
  const { openErrorAlert, openSuccessAlert, hideBanners } = React.useContext(BannerContext);

  const [toggleEmailInformationPage, setToggleEmailInformationPage] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [toggleSignUp, setSignUp] = useState(false);

  const handleContinue = (emailInput) => {
    updateEmailPreferences({
      emailAddress: emailInput,
      subscriptions: selectedItems,
      table: surveyEmailTableData,
      callback: (response) => {

        if (email !== emailInput) {
          setEmail(emailInput);
        }
        setSurveyEmailTableData(convertSubsToPrefs(surveyEmailTableData, getSubscriptions(response)));
        openSuccessAlert(determineMessage(selectedItems, surveyEmailTableData), emailInput);
        setSelectedItems([]);
      },
      err: (err) => {
        openErrorAlert();
      }
    });
  };

  const handleToggleEmailInformationPage = () => {
    setToggleEmailInformationPage(!toggleEmailInformationPage);
  };

  const handleSaveChanges = () => {
    if (selectedItems.length > 0) {
      hideBanners();
      if (!email) {
        setSignUp(true);
      } else {
        handleContinue(email);
      }
    }
  };

  return (
    <div className="component">
      <Row>
        <Col>
          <h2>
            <u style={{ textDecorationColor: '#F96302' }}>Survey Emails</u>
          </h2>
        </Col>
      </Row>
      <Row>
        <Col>
          <p>
            If you don&apos;t want to provide customer feedback, you can unsubscribe from our survey emails.
          </p>
        </Col>
      </Row>
      <Row>
        <Col>
          <PreferenceCard
            headerColumn={emailTableHeaders}
            tableData={surveyEmailTableData}
            name="surveys"
            hasIdentifier={!!email}
            setTableData={setSurveyEmailTableData}
            isMobile={isMobile}
            setSelectedItems={setSelectedItems}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <Row>
            <Col nopadding xs={6} sm={7} md={7} lg={7} />
            <Col fallback={12} xs={6} sm={5} md={5} lg={5}>
              <Row>
                <Col>
                  <Button
                    onClick={handleSaveChanges}
                    variant="primary"
                    data-testid="updateSurveyPreferenceButton"
                    fullWidth
                  >
                    Save Changes
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
      {toggleSignUp && (
        <SignUpModal
          setSignUp={setSignUp}
          type={constants.EMAIL}
          handleSignUpCallBack={handleContinue}
          selectedItems={selectedItems}
          setSelectedItems={setSelectedItems}
          setTableData={setSurveyEmailTableData}
          tableData={surveyEmailTableData}
        />
      )}

      {toggleEmailInformationPage && (
        <TextModal
          onModalClose={handleToggleEmailInformationPage}
          sections={EMAIL_INFORMATION_SECTIONS}
        />
      )}
    </div>
  );
}

export function SurveyEmailPreferences() {
  return (
    <ErrorBoundary>
      <BannerProvider>
        <Preferences />
      </BannerProvider>
    </ErrorBoundary>
  );
}
